import { Component, inject, Input, OnInit } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LatLng } from "leaflet";
import { cloneDeep } from "lodash";
import { AuthService } from "src/app/auth.service";
import { bohrpunktNummerLabel, idOf, isB, istPunktartMitNummer, istPunktartMitProtokoll, ProjectAssignment, punktTemplate } from "src/app/data-model";
import { ProjectDocument } from "src/app/project.service";
import { TransformationService, WmsDataService, StorageService} from '@luzula/luzula-lib';
import { ProjectService } from "src/app/project.service";
import { WeatherService } from '@luzula/luzula-lib';
import Punktarten from 'src/assets/json/Punktarten.json';

@Component({
    standalone: false,
    selector: 'bp-bohrpunkt-neu-modal',
    templateUrl: './bohrpunkt-neu.component.html',
    
})
export class BohrpunktNeuComponent implements OnInit {
	activeModal = inject(NgbActiveModal);
	private modalService = inject(NgbModal);

	@Input() bpTemplate?: any;
	@Input() position?: LatLng;
	bp!: any;
	
	isB = isB;
	istPunktartMitProtokoll = istPunktartMitProtokoll;
	istPunktartMitNummer = istPunktartMitNummer;
	bohrpunktNummerLabel = bohrpunktNummerLabel;

	private ps = inject(ProjectService);

	constructor(
		private as: AuthService,
		private storage: StorageService,
		private ts: TransformationService,
		private wms_data: WmsDataService,
		private weatherService: WeatherService
	) {}
	
	ngOnInit(): void {
		// Prüfen ob Projekt aktiv - Punkt-Erstellung nur bei offenem Projekt
		if (!this.ps.project()) {
			this.activeModal.dismiss('no-project');
			return;
		}

		if (this.bpTemplate) {
			this.bp = cloneDeep(this.bpTemplate);
			this.bp.header.nummer = '';
			this.bp.header.bemerkungen = '';
			delete this.bp._id;
			delete this.bp._rev;
		}
		else {
			this.bp = punktTemplate();
			this.storage.get('recentPointType').then((value: any) => {
				const valStr = value as string;
				const paIdx = (Punktarten as string[]).indexOf(valStr);
				if (paIdx === -1)
					this.bp.type = "6_Tiefbohrung";
				else
					this.bp.type = (Punktarten as string[]).at(paIdx);
			});
		}

		// Aktuelles Projekt zuweisen
		this.assignCurrentProject();

		this.as.user().subscribe((user: any) => {
			this.bp.header.aufnahme.kartierer = user?.name;
		});

		if (this.position) {
			const pt = this.ts.toEPSG5650(this.position);
			this.bp.header.koordinaten.x = pt.x;
			this.bp.header.koordinaten.y = pt.y;
			this.wms_data.fetchWmsDataForDocument(this.bp);
			this.fetchCurrentWeather(this.position);
		}
		else {
			const options = {
				enableHighAccuracy: true,
				timeout: 5000,
				maximumAge: 0,
			};
			const success = (pos: any) => {
				const latlng = new LatLng(pos.coords.latitude, pos.coords.longitude);
				const pt = this.ts.toEPSG5650(latlng);
				this.bp.header.koordinaten.x = pt.x;
				this.bp.header.koordinaten.y = pt.y;
				this.wms_data.fetchWmsDataForDocument(this.bp);
				this.fetchCurrentWeather(latlng);
			};

			const error = (err: any) => {
				console.warn(`ERROR(${err.code}): ${err.message}`);
			}

			navigator.geolocation.getCurrentPosition(success, error, options);
		}
	}

	private async fetchCurrentWeather(latlng: LatLng) {
		try {
			const weather = await this.weatherService.getCurrentWeather(latlng.lat, latlng.lng);
			if (weather) {
				const description = this.weatherService.describeWeather(weather);
				this.bp.extendedHeader.witterung = description.full;
			}
		} catch (error) {
			console.warn('[BohrpunktNeuComponent] Fehler beim Abrufen der Witterung:', error);
		}
	}
	
	onClose(redirect: boolean) {
		this.storage.setSync('recentPointType', this.bp.type);
		if (istPunktartMitProtokoll(this.bp.type)) {
			this.bp.Horizontfolge = [];
			this.bp.Substratfolge = [];
			this.bp.bodenvegetation = { /*bestandsBeschreibung: '', */aufnahme: { schichtAnteile: {}, vegetationen: [] } };
			this.bp.extendedHeader.relief = {};
			if (idOf(this.bp.type) === 7)
				this.bp.extendedHeader.entwaesserungsverhalten = 'II';
		}
		if (!istPunktartMitNummer(this.bp.type)) {
			delete this.bp.header.nummer;
		}
		this.activeModal.close({bp: this.bp, redirect: redirect});
	}

	openLegendModal(content: any): void {
		this.modalService.open(content);
	}

	private async assignCurrentProject(): Promise<void> {
		const projectId = this.ps.project();
		if (!projectId) return;

		const projectDoc = await this.ps.getOne(projectId) as ProjectDocument | undefined;
		const projectName = projectDoc?.name || projectId;

		if (!this.bp.header.projects) {
			this.bp.header.projects = [];
		}

		// Nur hinzufügen wenn nicht bereits zugewiesen
		const alreadyAssigned = this.bp.header.projects.some(
			(p: ProjectAssignment) => p.id === projectId
		);
		if (!alreadyAssigned) {
			this.bp.header.projects.push({ id: projectId, name: projectName });
		}
	}
}
